import { SagaIterator } from 'redux-saga';
import { all, AllEffect } from 'redux-saga/effects';

import { entry as vkEntry } from '../services/vk';
export type TRootSaga = Generator<AllEffect<SagaIterator>, void, unknown>;

// Base static sagas here, dynamic sagas will be placed later on demand
export default function* root(): TRootSaga {
  yield all([
    vkEntry.sagas(),
  ]);
}
